// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useDifusiones } from "../context/DifusionesContext";
import { useBody } from "../../Body/state/BodyContext";
import { Modal, Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
import SelectAreasDesvincular from "./SelectAreasDesvincular";
import { FormProvider, useForm } from "react-hook-form";

const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    boxShadow: 24,
    padding: '25px',
    width: 420,
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
        width: '85%',
    },
}));

export const DesvincularListaModal = ({ open, onClose, listaSeleccionada, onSuccess }) => {
    const { desvincularLista, areasUser } = useDifusiones();
    const { setMessage, setSuccess } = useBody();
    const { register } = useForm();
    const [areasSeleccionadas, setAreasSeleccionadas] = useState([]);
    const [loading, setLoading] = useState(false);

    const areasCompartidasConUsuario = areasUser.filter(area =>
        listaSeleccionada.compartidos?.some(compartido => compartido.id === area.id)
    );

    useEffect(() => {
        setAreasSeleccionadas(areasCompartidasConUsuario.map(area => area.id));
    }, [listaSeleccionada]);

    const handleDesvincular = async () => {
        setLoading(true);
        try {
            await desvincularLista(listaSeleccionada.id, areasSeleccionadas);
            setSuccess("Lista desvinculada exitosamente");
            onSuccess(listaSeleccionada.id);
            onClose();
        } catch (error) {
            console.error("Error al desvincular la lista:", error);
            setMessage("Error al desvincular la lista");
        } finally {
            setLoading(false);
        }
    };

    const esSolo = areasCompartidasConUsuario.length === 1;

    return (
        <Modal open={open} onClose={onClose}>
            <Root>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <ElectricalServicesIcon color="error" />
                        <Typography variant="h6">Desvincular lista</Typography>
                    </Box>

                    {esSolo ? (
                        <Typography variant="body1" color="text.secondary">
                            ¿Seguro que querés desvincular <strong>{listaSeleccionada?.nombre}</strong> del área <strong>{areasCompartidasConUsuario[0]?.name}</strong>?
                        </Typography>
                    ) : (
                        <FormProvider {...{ register }}>
                            <SelectAreasDesvincular
                                areasCompartidasConUsuario={areasCompartidasConUsuario}
                                areasSeleccionadas={areasSeleccionadas}
                                setAreasSeleccionadas={setAreasSeleccionadas}
                            />
                        </FormProvider>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button sx={{ textTransform: 'none' }} variant="outlined" onClick={onClose} disabled={loading}>
                            Cancelar
                        </Button>
                        <Button
                            sx={{ textTransform: 'none' }}
                            variant="contained"
                            color="error"
                            disabled={loading}
                            onClick={handleDesvincular}
                        >
                            {loading ? 'Desvinculando...' : 'Desvincular'}
                        </Button>
                    </Box>
                </Box>
            </Root>
        </Modal>
    );
};
